import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

const STEPS = ['Katalog', 'Detail', 'Bayar'] as const;

/** The three purchase steps: 0 Katalog · 1 Detail · 2 Bayar. */
export function StepIndicator({ current }: { current: 0 | 1 | 2 }) {
  return (
    <nav className="flex items-center gap-1.5" aria-label="Langkah pembelian">
      {STEPS.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={label} className="flex items-center gap-1.5">
            <span
              className={cn(
                'flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold tnum',
                done
                  ? 'bg-success text-white'
                  : active
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-secondary text-ink-400',
              )}
              aria-current={active ? 'step' : undefined}
            >
              {done ? <Check className="h-3.5 w-3.5" /> : i + 1}
            </span>
            <span
              className={cn(
                'hidden text-sm font-medium sm:inline',
                active ? 'text-ink-900' : 'text-ink-400',
              )}
            >
              {label}
            </span>
            {i < STEPS.length - 1 && <span className="mx-0.5 h-px w-5 bg-border sm:w-6" />}
          </div>
        );
      })}
    </nav>
  );
}
